import { combineReducers } from 'redux';
import {
    Auth,
    Categories,
    Email,
    Feedback,
    File,
    Help,
    Home,
    Location,
    Map,
    NewSpot,
    PendingSpots,
    PublicProfile,
    SearchBar,
    Menu,
    SessionStatus,
    Spots,
    SpotDrafts,
    User,
} from 'store/slices';

const rootReducer = combineReducers({
    auth: Auth,
    spots: Spots,
    user: User,
    email: Email,
    newSpot: NewSpot,
    categories: Categories,
    file: File,
    sessionStatus: SessionStatus,
    home: Home,
    location: Location,
    publicProfile: PublicProfile,
    feedback: Feedback,
    searchBar: SearchBar,
    menu: Menu,
    map: Map,
    help: Help,
    spotDrafts: SpotDrafts,
    pendingSpots: PendingSpots,
});

export default rootReducer;
